import React, { useEffect, useRef } from "react";
import { CiSearch } from "react-icons/ci";
import { IoIosMore } from "react-icons/io";
import { IoVideocamOutline } from "react-icons/io5";
import BreadCrums from "../Breadcrums/BreadCrums";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getDomainInfo } from "../../utils/utils";


const HeaderSection = ({ showMenu, setShowMenu }) => {
  const profileimg = useSelector((state) => state.fetchUser?.user?.profileImg);
  const { userId } = useParams();
  const token = localStorage.getItem("token");
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);

  const myAccountLinkStyle = {
    color: '#888', // Grey color
    textDecoration: 'none', // Remove underline
    fontSize: '12px', // Smaller font size
    fontWeight: '500', // Optional: to make the text slightly bolder
  };

  const defaultImageUrl = process.env.REACT_APP_S3_URL || "/assets/images/defultprofileimage.png";

  const imageUrl = profileimg && profileimg.includes("https://hello-image-bucket.s3")
      ? profileimg
      : defaultImageUrl + profileimg;



  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowMenu]);
  
  

  return (
    <div className="profile-row-box">
      {/* Header Icons Section */}
      <div className="header-container">
        <div className="icons-left">
        <figure className="profile-icon"><img src={imageUrl} alt="Profile" className="profile-img" /></figure>
        {/* <div className = "follower-info">2K followers | 640 shopped</div> */}
        </div>
        { <div className="icons-right">
          {/* <CiSearch className="icon" /> */}
           {/* <IoVideocamOutline className="icon" />  */}

          <div className="dropdown-container" ref={dropdownRef}>
            <IoIosMore
              className="icon more-icon"
              onClick={() => setShowMenu(!showMenu)}
            />
            {showMenu && (
              <div className="dropdown">
                <ul>
                <li>
                  <Link
  to={token
    ? (isPredefinedDomain ? `/${uid}/myaccount` : "/myaccount")
    : (isPredefinedDomain ? `/${uid}/login` : "/login")}
  className="user"
  style={{ ...myAccountLinkStyle }} // Combine both styles
>
  My Account
</Link>
                </li>
                  {/* <li>Share</li>
                  <li>About Us</li>
                  <li>Contact Us</li> */}
                </ul>
              </div>
            )}
          </div>
        </div> }
      </div>
    </div>
  );
};

export default HeaderSection;
